import type { ComponentProps } from 'preact';
import type { JourneyPlan } from '../../../../arcticapi/types';
import { buildItinerarySteps } from '../formatters';
import { JourneyPlanTypedItineraryStep } from '../ItineraryStep/TypedItineraryStep';
import { useTenantWebsiteBaseHref } from '../../../../config/TenantContext';
import type { ItineraryBoardingStep } from '../itinerarySteps';
import styles from './JourneyPlanItinerary.module.css';

export interface JourneyPlanItineraryProps extends Omit<
  ComponentProps<'article'>,
  'children' | 'className'
> {
  plan: JourneyPlan;
  onShowStopDeparturesDetails?: (step: ItineraryBoardingStep) => void;
  onShowLineTimetableDetails?: (step: ItineraryBoardingStep) => void;
}

/**
 * Represents a complete journey itinerary option.
 *
 * Intended to include a list of step-by-step legs.
 */
export function JourneyPlanItinerary({
  plan,
  onShowStopDeparturesDetails,
  onShowLineTimetableDetails,
  ...props
}: JourneyPlanItineraryProps) {
  const tenantWebsiteBaseHref = useTenantWebsiteBaseHref();
  const itinerarySteps = buildItinerarySteps(plan, tenantWebsiteBaseHref);

  return (
    <article {...props} className={styles.itinerary}>
      {/* IDEA TICKET RAISED FOR BELOW */}
      {/* <Heading as="h3" variant="md" color="default" className={styles.heading}>
        {formatItineraryTimeRange(plan)}
      </Heading>
      <p className={styles.duration}>
        {formatDuration(getItineraryDurationMinutes(plan))}
      </p> */}
      <ol className={styles.steps}>
        {itinerarySteps.map((step, stepIndex) => (
          <JourneyPlanTypedItineraryStep
            key={step.key}
            step={step}
            isFirstStep={stepIndex === 0}
            isLastStep={stepIndex === itinerarySteps.length - 1}
            onShowStopDeparturesDetails={onShowStopDeparturesDetails}
            onShowLineTimetableDetails={onShowLineTimetableDetails}
          />
        ))}
      </ol>
    </article>
  );
}
